import { Extension } from '@tiptap/core'
import { Plugin } from 'prosemirror-state'

import { store } from '@/store'

let debounce = null

export const Scroll = Extension.create({
  name: 'scroll_handler',

  addProseMirrorPlugins () {
    return [
      new Plugin({
        props: {
          scrollThreshold: { bottom: 80 },
          scrollMargin: { bottom: 80 },

          handleKeyDown () {
            clearTimeout(debounce)

            debounce = setTimeout(() => {
              store.commit('setUpdatedAt')
            }, 400)

            return false
          }
        }
      })
    ]
  }
})
